import React from 'react';

export const AddInvestmentIcon = () => (
  <svg
    width="31px"
    height="28px"
    viewBox="0 0 31 33"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Group 63</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-63" transform="translate(-2.000000, 1.000000)">
        <g
          id="Icon-/-Illustrative-/-Investment-/-30px"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g id="Investment-72px" transform="translate(3.000000, 0.000000)">
            <g
              id="Group-12"
              transform="translate(0.125000, 0.625000)"
              strokeWidth="1.5"
            >
              <path
                d="M10.1785714,9.16071429 C10.1785714,10.4726643 11.3936667,11.5357143 12.8928571,11.5357143 C14.3920476,11.5357143 15.6071429,10.4726643 15.6071429,9.16071429 C15.6071429,7.84971429 14.3920476,6.78571429 12.8928571,6.78571429 C11.3936667,6.78571429 10.1785714,5.72266429 10.1785714,4.41071429 C10.1785714,3.09971429 11.3936667,2.03571429 12.8928571,2.03571429 C14.3920476,2.03571429 15.6071429,3.09971429 15.6071429,4.41071429"
                id="Stroke-32"
                stroke="#5EDAB0"
              />
              <path
                d="M12.5535714,-1.03620816e-14 L12.5535714,1.52187078"
                id="Stroke-34"
                stroke="#5EDAB0"
              />
              <path
                d="M12.5535714,11.5357143 L12.5535714,13.0575851"
                id="Stroke-34"
                stroke="#5EDAB0"
              />
              <path
                d="M9.02522328,21.239509 C10.4004417,19.8642906 10.7174526,16.1628209 9.02522328,14.4705915 C7.03290524,12.4782735 3.03134687,12.2142857 0,12.2142857 C0,15.2467607 0.263987781,19.247191 2.25630582,21.239509 C3.94853519,22.9317384 7.65000488,22.6147274 9.02522328,21.239509 L9.02522328,21.239509 Z"
                id="Stroke-6"
                stroke="#064765"
              />
              <path
                d="M14.7247767,23.9537947 C13.3495583,22.5785763 13.0325474,18.8771066 14.7247767,17.1848772 C16.7170948,15.1925592 20.717525,14.9285714 23.75,14.9285714 C23.75,17.9610465 23.4860122,21.9614767 21.4936942,23.9537947 C19.8014648,25.6460241 16.0999951,25.3290131 14.7247767,23.9537947 L14.7247767,23.9537947 Z"
                id="Stroke-8"
                stroke="#064765"
              />
              <path
                d="M19.6785714,19.2073413 C18.3143297,19.8376399 11.6401099,17.377809 11.6401099,28.5 C11.6401099,14.6681979 5.56303297,17.7583274 4.75,16.9642857"
                id="Stroke-10"
                stroke="#064765"
              />
            </g>
          </g>
        </g>
        <g id="Group-4-Copy" transform="translate(18.000000, 17.000000)">
          <circle id="Oval" fill="#FFFFFF" cx="7.5" cy="7.5" r="7.5" />
          <g
            id="Group-60"
            transform="translate(2.000000, 2.000000)"
            stroke="#042F43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          >
            <path
              d="M-8.8817842e-15,5.25346236 C-8.8817842e-15,2.35250044 2.35250044,-2.29949393e-12 5.25346236,-2.29949393e-12 C8.15442427,-2.29949393e-12 10.5069247,2.35250044 10.5069247,5.25346236 C10.5069247,8.15442427 8.15442427,10.5069247 5.25346236,10.5069247 C2.35250044,10.5069247 -8.8817842e-15,8.15442427 -8.8817842e-15,5.25346236 L-8.8817842e-15,5.25346236 Z"
              id="Stroke-281"
            />
            <path
              d="M3.06451971,5.25346236 L7.2964755,5.25346236"
              id="Stroke-283"
            />
            <path
              d="M5.25346236,3.06451971 L5.25346236,7.2964755"
              id="Stroke-285"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
